import { useTranslation } from 'react-i18next';
import {useEffect, useState} from "react";
import { noticeDetailUrl } from '../../../../../constants/adeleUrl';
import SysConfigStore from '../../../../../store/common/SysConfigStore';
import { navigateToAdele } from '../../../../../util/commonUtils';
import ButtonText from '../../../../ui/buttons/ButtonText';
import CardBox from '../../../../ui/containers/CardBox';
import {useNoticeDictList} from "../../../../../hooks/useNoticeDictList";
import {DashboardNotice} from "../../../../../model/api/dashboard";

export default function NoticeListDashboard() {
	const { isComponentEnabled , getSysConfigValue} = SysConfigStore();
	const { t } = useTranslation();
	const {
		getData: { data: noticeDictList },
	} = useNoticeDictList();

	const announcementNoticeId = getSysConfigValue('ANNOUNCEMENT_NOTICE_BOARD_ID');

	const [selectedBoard, setSelectedBoard] = useState<string | null>(null);

	const boardEntries = Object.entries(noticeDictList ?? {}).sort(([, a], [, b]) => {
		const idA = String(a.board_id);
		const idB = String(b.board_id);

		if (announcementNoticeId) {
			if (idA === announcementNoticeId) return -1;
			if (idB === announcementNoticeId) return 1;
		}

		return Number(idA) - Number(idB);
	});


	useEffect(() => {
		if (!selectedBoard && boardEntries.length > 0) {
			setSelectedBoard(boardEntries[0][0]);
		}
	}, [boardEntries, selectedBoard]);

	const detailUri = isComponentEnabled('CMPNT171_CUSTOM_NOTICE_BOARD_BF')
		? '/manage/notice-board-detail-view/'
		: noticeDetailUrl;

	const handleNavigate = (noticeId: number) => {
		sessionStorage.setItem(
			detailUri,
			JSON.stringify({
				notice_id: noticeId,
			}),
		);

		navigateToAdele(detailUri);
	};

	return (
		<CardBox
			className={`h-full p-6 ${
				boardEntries.length === 0 ? 'flex items-center justify-center' : 'flex flex-col gap-4'
			}`}
		>
			{boardEntries.length === 0 ? (
				<p className="text-lg text-black font-medium">
					{t('cmmn_guide_no_notice_data_in_noticeboard')}
				</p>
			) : (
				<>
					<div
						className="overflow-x-auto scroll-smooth px-4"
						role="tablist"
					>
						<div className="whitespace-nowrap flex gap-4 min-w-max">
							{boardEntries.map(([key]) => (
								<button
									key={key}
									type="button"
									role="tab"
									aria-selected={selectedBoard === key}
									onClick={() => setSelectedBoard(key)}
									title={key}
									className={`text-lg font-semibold px-2 pb-1 transition-colors
										  ${selectedBoard === key ? 'border-b-2 border-black text-black' : 'text-neutral-400'}
									  `}
								>
									{key}
								</button>
							))}
						</div>
					</div>

					{boardEntries.map(([boardName, boardData]) =>
							selectedBoard === boardName && (
								<ul key={boardName} className="flex flex-col gap-2">
									{boardData.notices.length === 0 ? (
										<p className="text-sm text-neutral-400">{t('MSG_ID_1177')}</p>
									) : (
										boardData.notices.slice(0, 5).map((notice: DashboardNotice) => {
											const {
												id,
												notice_title: title,
												main_notice: mainNotice,
												genre_name: genreName,
												notice_updated: updatedAt,
											} = notice;

											return (
												<ButtonText
													key={id}
													className="flex items-center justify-between p-0 gap-1"
													onClick={() => handleNavigate(id)}
												>
													{mainNotice && (
														<span
															className="px-2 py-1 text-m font-bold border border-neutral-500 rounded-3xl">
													{genreName}
												</span>
													)}
													<p className="flex-1 font-bold text-neutral-600 truncate text-left">{title}</p>
													<p className="text-sm text-neutral-600 truncate">{updatedAt}</p>
												</ButtonText>
											);
										})
									)}
								</ul>
							)
					)}
				</>
			)}
		</CardBox>
	);
}
